import { App, Flex, Spin } from 'antd';
import { getContactById } from 'api/customers';
import withGuard from 'components/withGuard';
import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useParams } from 'react-router';
import { Route } from 'react-router-dom';
import { captureException } from 'utils/errors';
import Layout from 'components/Layout';
import AdjustBalance from './AdjustBalance';
import Container from './Container';
import CreditHistory from './CreditCardHistory';
import GiftCardHistory from './GiftCardHistory';
import Overview from './Overview';
import ContactOverview from './ContactOverview';

const ROUTES = [
  {
    label: 'Overview',
    path: '',
    Component: Overview,
    key: 1,
  },
  {
    label: 'Credit history',
    path: '/credit-history',
    Component: CreditHistory,
    key: 2,
  },
  {
    label: 'Gift card details',
    path: '/gift-card',
    Component: GiftCardHistory,
    key: 3,
  },
  {
    label: 'Adjust balance',
    path: '/adjust-balance',
    Component: AdjustBalance,
    key: 4,
  },
  {
    title: 'Overview',
    path: '/orders/:orderId',
    Component: Overview,
    id: 6,
  },
];

function CustomerDetail() {
  const [contact, setContact] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    const getCustomerData = () => {
      setContact(null);
      getContactById(id)
        .then((data) => {
          setContact(data);
        })
        .catch((e) => {
          captureException(e);
          message.error('Contact not found');
          navigate('/console/contacts');
        });
    };
    getCustomerData();
  }, [id]);

  if (!contact) {
    return (
      <Flex justify="center" align="center" className="h-[50vh]">
        <Spin size="large" />
      </Flex>
    );
  }
  if (contact.customer) {
    return (
      <Routes>
        <Route path="" element={<Container />}>
          {ROUTES.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component customer={contact.customer} />} />
          ))}
        </Route>
      </Routes>
    );
  }
  return (

    <Layout header={(
      <Layout.Header
        backTitle="Contacts"
        // backPath="/console/contacts"
      />
    )}
    >
      <ContactOverview contact={contact} />
    </Layout>
  );
}

export default withGuard(CustomerDetail, null, { redirect: true });
